export const transportRequestStates = {
  rejected: 'REJECTED',
  withdrawn: 'WITHDRAWN',
  accepted: 'ACCEPTED',
  created: 'CREATED'
}
